import React, { useState } from 'react';
import AttendanceList from './AttendanceList';
import AddAttendance from './AddAttendance';
import Card from '../ui/Card';

const initialAttendance = [
    { id: 1, student: 'John Doe', status: 'Present' },
    { id: 2, student: 'Jane Smith', status: 'Absent' },
];

const AttendanceManagement = () => {
    const [attendance, setAttendance] = useState(initialAttendance);

    return (
        <Card title="Attendance Management">
            <AddAttendance setAttendance={setAttendance} />
            <AttendanceList attendance={attendance} />
        </Card>
    );
};

export default AttendanceManagement;
